import { createContext, useContext } from "react";
import { useStablesLimits } from "../Hooks/useStablesLimits";

const StablesLimitsContext = createContext(null);

/** Fetches GET /v1/stables/limits once per operation page tree. */
export const StablesLimitsProvider = ({ children }) => {
  const value = useStablesLimits();
  return (
    <StablesLimitsContext.Provider value={value}>
      {children}
    </StablesLimitsContext.Provider>
  );
};

export const useStablesLimitsContextOptional = () => useContext(StablesLimitsContext);

export const useStablesLimitsContext = () => {
  const context = useStablesLimitsContextOptional();
  if (!context) {
    throw new Error("useStablesLimitsContext must be used within StablesLimitsProvider");
  }
  return context;
};
